import React from 'react';
import PlayTestContainer from 'containers/PlayTestContainer';

function PlayTestPage() {
    return (
        <PlayTestContainer />
    )
}

export default PlayTestPage;